<script setup>
import { ref } from 'vue';
import TransactionPanel from '@maison/components/organisms/transactionPanel/TransactionPanel.vue';
import { PhxClusterSlider } from '@phx-styleguides/iwc';
import { PhxsgDivider } from '@sg/src/View/Components/Atoms/Divider';
import { PhxGridLayout } from '@sg/src/View/Components/Atoms/GridLayout';
import { PhxScrollIncentive } from '@sg/src/View/Components/Atoms/ScrollIncentive';

defineProps({
  id: {
    type: String,
    required: true,
  },
  slides: {
    type: Array,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
});

const activeSlideIndex = ref(0);

function onSlideChange(index) {
  activeSlideIndex.value = index;
}

function scrollDown() {
  window.scrollBy(0, window.innerHeight);
}
</script>

<template>
  <phx-cluster-slider :id="id" :slides="slides" :label="label" @slide-change="onSlideChange" />

  <phx-grid-layout class="cluster-slider__content-grid">
    <div
      v-for="(slide, index) in slides"
      :key="`${id}-content-${index}`"
      :class="['cluster-slider__content', { 'is-active': index === activeSlideIndex }]"
      :aria-hidden="index !== activeSlideIndex"
      :inert="index !== activeSlideIndex"
    >
      <p class="flex justify-between title-caption">
        <span>{{ $t('ClusterSlider.sizes') }}</span>
        <span>{{ slide.sizes }}</span>
      </p>

      <phxsg-divider spacing="2" />

      <p class="mt-2">{{ slide.description }}</p>

      <a :href="slide.data.content.action.href" type="button" class="btn mt-4 md:hidden btn--link">
        <span class="btn__text">{{ slide.data.content.action.label }}</span>
      </a>
    </div>

    <transition name="cluster-slider__transaction-panel">
      <div v-if="slides[activeSlideIndex]">
        <transaction-panel v-bind="slides[activeSlideIndex].panel" />
      </div>
    </transition>
  </phx-grid-layout>

  <phx-scroll-incentive
    class="scroll-incentive cluster-slider__scroll-incentive max-sm:hidden"
    :label="$t('ClusterSlider.scrollToNextSection')"
    @click="scrollDown"
  />
</template>
